import React from 'react';
import SetoCanvasPage from 'pages/SetoCanvasPage';

import {useState, useEffect} from 'react';
import HeaderBanner from 'views/HeaderBanner';
import ProductAPI from 'service/api/ProductAPI';
import ProductStore from 'stores/ProductStore';
import AppConstants from 'AppConstants';
import ProductList from 'views/product/ProductList';
import AppUtil from 'AppUtil';

const BANNERS = {"tshirt": ["/images/banners/shop_tshirt.jpg", "/images/banners/shop_tshirt2.jpg"], 
					"hoodies": ["/images/banners/shop_hoodies.jpg"],
					"sweatshirt": ["/images/banners/shop_sweatshirt.jpg"]};

function ProductsByTypePage(props) {
	const productTypeUrl = props.match.params[0].toLowerCase();
	const [loadMore, setLoadMore] = useState(true);
	const [products, setProducts] = useState(ProductStore.getProductsByType(productTypeUrl));

	const pagination = ProductStore.getProductsByTypePagination(productTypeUrl);

	const onLoadMore = () => {
		if(loadMore === false) 
			setLoadMore(true);
	};

	useEffect(() => {
		const recentProducts = ProductStore.getProductsByType(productTypeUrl);
		setProducts(recentProducts);

		const recentPagination = ProductStore.getProductsByTypePagination(productTypeUrl);
		if(recentPagination.nextPageNumber === 0 && loadMore === false)
			setLoadMore(true);
	}, [productTypeUrl]);

	useEffect(() => {
		const listener = ProductStore.addListener(() => {
			setProducts(ProductStore.getProductsByType(productTypeUrl));
		});
		
		if(loadMore === true) {
			const productType = AppUtil.findProductTypeFromURL(productTypeUrl);
			ProductAPI.getProductsByType(productType, pagination.nextPageNumber, AppConstants.DEFAULT_PRODUCT_PAGE_SIZE, function() {
				setLoadMore(false);
			});	
		}

		return () => listener.remove();
	}, [productTypeUrl, loadMore]);
	
	const headerImg = BANNERS[productTypeUrl]? BANNERS[productTypeUrl].sort(() => .5 - Math.random())[0]: null;
	
	return <SetoCanvasPage id="typeProducts" title={productTypeUrl.toUpperCase()+" | Seto Canvas"} 
							metaDescription={"Purchase "+productTypeUrl+" and many more at SetoCanvas.com"}>
						

				{headerImg && 
				<HeaderBanner bannerImages={[{img: headerImg, title: "Shop "+productTypeUrl.toUpperCase()+" at setocanvas.com"}]} />
				}
					
				<ProductList products={products} flattenProductImages={true} 
								emptyMsg="Coming Soon!!!" 
								loadMore={onLoadMore} 
								hasMore={pagination.hasMore} />
	</SetoCanvasPage>
	
}

export default ProductsByTypePage;




// WEBPACK FOOTER //
// ./src/pages/ProductsByTypePage.js